export default __webpack_public_path__ + "static/media/without-plugin.3e1375e9.gif";